import { useLocale } from '../hooks/i18n/useLocale.js'
import { NOT_FOUND_COPY } from '../data/workshop-packages.js'

function NotFoundPage() {
  const { locale } = useLocale()
  const copy = NOT_FOUND_COPY[locale === 'nb' ? 'nb' : 'en']
  const [titleMain, titleSub] = copy.title.split('\n')
  return (
    <main className="flex min-h-[100dvh] flex-col items-start justify-center gap-6 bg-background px-6 text-foreground">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">404</p>
      <h1 className="text-4xl font-semibold tracking-tighter">
        {titleMain}
        {titleSub ? (
          <>
            <br />
            <span className="text-muted-foreground">{titleSub}</span>
          </>
        ) : null}
      </h1>
      <a href="/" className="border border-border px-6 py-3 text-sm font-medium">
        {copy.home}
      </a>
    </main>
  )
}

export default NotFoundPage
